export default __webpack_public_path__ + "static/media/connect-hover.a2a06104.png";